/**
 * Turns the constructor's selectedItemList into the chargeDataList the MC/DS backends expect
 * (both games share the same charge contract). Used by the single-user charger and the mass-charge wizard.
 */
export function buildChargeDataListMcDs(selectedItemList) {
    try {
        let dataList = []

        selectedItemList.forEach(item => {
            // Skip items with no type selected
            if (!item.item || !item.item.value) return;

            let data = {
                "keys": [item.item.guidMap !== "" && item.guid ? item.guid.guid : ""],
            }

            let amountAttribute = item.item.amountAttribute != undefined && item.item.amountAttribute != '' ? item.item.amountAttribute : 'count'
            if(item.item.amount !== false)
                data[amountAttribute] = item.amount === undefined ? 0 : item.amount

            if(item.mephistoTag !== undefined && item.mephistoTag !== "") {
                data["mephistoTag"] = item.mephistoTag
            }

            if(item.item.hasOwnProperty('key'))
                data[item.item.key] = item.item.guidMap != "" ? item.guid?.guid : ""

            if (item.item.guidMap2 != "" && item.guid2?.guid != null) {
                data[item.item.key2] = item.item.guidMap2 !== false ? item.guid2.guid : ""
                data["keys"].push(item.guid2.guid)
            }

            if (item.endTime && item.item.endTime === true) {
                // templates store endTime as an ISO string, the constructor as dayjs
                data['endTime'] = typeof item.endTime === "string" ? item.endTime : item.endTime.format('YYYY-MM-DDTHH:mm:ss[Z]')
            }

            if(
                item.hasOwnProperty('guid') && item.guid != '' &&
                item.guid.hasOwnProperty('label') &&
                item.guid.hasOwnProperty('x') &&
                item.guid.hasOwnProperty('y')
            ) {
                if(item.guid.label != null) {
                    data["label"] = item.guid.label;
                    data["mockSize"] = {x:parseInt(item.guid.x), y:parseInt(item.guid.y)};
                }
            }

            dataList.push({
                "type": item.item.value,
                "data": data,
                "displayName": item.guid ? item.guid.displayName : (item.guid2 ? item.guid2.displayName : item.item.name)
            })
        })

        return dataList
    } catch (e) {
        return []
    }
}
